import * as React from 'react';
export const ezlinkSvg = React.forwardRef(function ezlinkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0C00BA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.555 6.442c3.072-1.795 7.036-1.916 10.226-.353a11.01 11.01 0 0 1 4.28 3.686c-3.745 3.75-7.489 7.498-11.236 11.246-.328.35-.681.677-1.036 1.002 1.43.723 3.113.992 4.68.62 2.106-.43 3.941-1.967 4.781-3.94.342-1.04 1.068-2.012 2.11-2.417.825-.388 1.757-.296 2.64-.295-.031 2.39-.792 4.771-2.253 6.67-1.12 1.483-2.628 2.652-4.317 3.419-2.32.988-4.983 1.223-7.413.496-2.48-.635-4.602-2.286-6.1-4.332 4.088-4.098 8.186-8.186 12.268-12.287-1.389-.692-3.018-.97-4.544-.63-2.099.394-3.954 1.882-4.828 3.827-.282.597-.484 1.26-.983 1.721-.442.525-1.075.833-1.722 1.02-.689.182-1.406.099-2.108.118-.031-3.879 2.168-7.684 5.555-9.571Z',
      fill: '#12D86C',
    }),
  );
});
ezlinkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ezlink = {
  category: 'brand',
  colorable: false,
  name: 'ezlink',
  svg: ezlinkSvg,
};
